import Vue from 'vue'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import moment from 'moment-timezone'

export default Vue.extend({
  components: { DatePicker },
  template: `
    <div>
      <div>
        <date-picker format="YYYY-MM-DD" inline v-model="filterText" placeholder="Filter..."/>
      </div>
      <div align="right" class="m-2">
      <a-button type="primary" @click="updateFilter">Search</a-button>
      <a-button @click="clear" :disabled="filterText===null">Clear</a-button>
      </div>
    </div>
    `,
  data: function () {
    return {
      filterText: null,
    }
  },
  methods: {
    clear() {
      this.filterText = null
      this.updateFilter()
    },
    updateFilter() {
      this.params.filterChangedCallback()
    },
    doesFilterPass(params) {
      // make sure each word passes separately
      return true
    },
    isFilterActive() {
      return this.filterText != null && this.filterText !== ''
    },
    getModel() {
      const data = {
        filter: this.filterText && this.filterText !== '' ? moment(this.filterText).format('YYYY-MM-DD') : '',
        filterType: 'text',
        type: 'contains',
      }
      return data
    },
    setModel(model) {
      this.filterText = model ? model.value : ''
    },
  },
})
